import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import NotificationProvider from '../providers/NotificationProvider';
import ScrollToTop from '../components/common/ScrollToTop';
import CanonicalLink from '../components/CanonicalLink';
import { usePageMeta } from '../helpers/hooks/usePageMeta';

const Router = () => {
  const defaultPageMeta = usePageMeta();

  return (
    <BrowserRouter>
      <NotificationProvider>
        <ScrollToTop>
          {defaultPageMeta}
          <CanonicalLink />
          <Routes />
        </ScrollToTop>
      </NotificationProvider>
    </BrowserRouter>
  );
};

export default Router;
